module.exports = __webpack_public_path__ + "static/media/search.adfd0e46.svg";